module.exports = __webpack_public_path__ + "img/vmc_aniv9_24Aug2021.4168511e.jpg";